<app-breadcrumbs title="{{ id ? 'DATA_SYNC.EDIT_TITLE' : 'DATA_SYNC.CREATE_TITLE' }}" [first]="'MENU.DATA_SYNC.MAIN'"
    [url]="'/data-sync'" [id]="breadcrumbsId">
</app-breadcrumbs>

<div class="btn-container">
    <dx-button *ngIf="((authorities.create && id == null) || (authorities.update && id != null))"
        class="ml-2 navbar-button" [height]="32" stylingMode="contained" icon="save" [disabled]="!pendingChanges"
        [text]="'SHARED.SAVE_CHANGES' | translate" type="success" (onClick)="saveChanges($event)"></dx-button>
</div>

<div class="row mb-2">
    <div class="col-12 col-xxl-5">
        <dx-form #form class="form-vertical" [formData]="formData" [showColonAfterLabel]="false"
            (onFieldDataChanged)="fieldDataChanged($event)">
            <dxi-item dataField="recordsPerDataPatch" editorType="dxTextBox">
                <dxo-label location="left" alignment="left"
                    [text]="'DATA_SYNC.CONFIGURATION.RECORDS_PER_DATA_PATCH' | translate"></dxo-label>
            </dxi-item>
            <dxi-item dataField="dataPatchesPerRequest" editorType="dxTextBox">
                <dxo-label location="left" alignment="left"
                    [text]="'DATA_SYNC.CONFIGURATION.DATA_PATCHES_PER_REQUEST' | translate"></dxo-label>
            </dxi-item>
        </dx-form>
    </div>
</div>

<div class="row mb-5">
    <div class="col-12">
        <dx-tab-panel #tabPanel class="form-panel normal-white-space-header" [dataSource]="tabs" [selectedIndex]="0"
            [loop]="false" [animationEnabled]="true" [swipeEnabled]="true">
            <div *dxTemplate="let tab of 'title'">
                <span>{{'DATA_SYNC.CONFIGURATION.CONFIGURATION_ITEMS' | translate}}</span>
            </div>
            <div *dxTemplate="let tab of 'item'">
                <div *ngIf="tab == 'ITEMS'">
                    <dx-data-grid class="smaller-header" [dataSource]="formData?.configurationItems"
                        [showColumnLines]="false" [showRowLines]="true" [showBorders]="true"
                        [rowAlternationEnabled]="true" (onToolbarPreparing)="onToolbarConfigurationPreparing($event)"
                        [masterDetail]="{ enabled: true, template: 'syncItems' }">

                        <dxi-column cellTemplate="rowTemplate" dataType="string" [allowFiltering]="false" [allowSorting]="false"
                            [caption]="'SHARED.ROW_NUMBER' | translate"></dxi-column>

                        <dxi-column dataField="type" dataType="string" [allowFiltering]="false" [allowSorting]="false"
                            [caption]="'SHARED.TYPE' | translate"></dxi-column>
                  <!-- <dxi-column dataField="id" dataType="string" [allowFiltering]="false" [allowSorting]="false"
                            [caption]="'SHARED.ID' | translate"></dxi-column>
                        <dxi-column dataField="version" dataType="string" [allowFiltering]="false"
                            [allowSorting]="false"></dxi-column>       -->

                        <dxi-column cellTemplate="actionsTemplate" [allowFiltering]="false" [allowSorting]="false"
                            [fixed]="true" fixedPosition="right" [width]="70" [caption]="''" [cssClass]="'actions'">
                        </dxi-column>

                        <div *dxTemplate="let template of 'actionsTemplate'">
                            <span class="table-icon dx-icon-edit" [title]="'SHARED.EDIT' | translate"
                                (click)="openConfigurationItem(template.data)"></span>
                            <span class="table-icon dx-icon-trash" [title]="'SHARED.DELETE' | translate"
                                (click)="deleteConfigurationItem(template.data)"></span>
                        </div>
                        
                        <div *dxTemplate="let row of 'rowTemplate'">
                            <text class="text-center" >{{ getRowNumber(row.data, formData?.configurationItems) }}</text>
                        </div>

                        <div *dxTemplate="let template of 'syncItems'">
                            <div class="container">
                                <span
                                    class="details-title">{{ 'DATA_SYNC.CONFIGURATION.SYNC_ITEMS' | translate }}</span>
                                <dx-data-grid class="smaller-header" [dataSource]="template.data.syncItems"
                                    [showColumnLines]="false" [showRowLines]="true" [showBorders]="true"
                                    [rowAlternationEnabled]="true">
                                    
                                    <dxi-column cellTemplate="rowTemplate" dataType="string" [allowFiltering]="false" [allowSorting]="false"
                                    [caption]="'SHARED.ROW_NUMBER' | translate"></dxi-column>

                                    <dxi-column dataField="clientSpecific" dataType="boolean" [allowFiltering]="false"
                                        [allowSorting]="false"></dxi-column>
                                    <!-- <dxi-column dataField="id" dataType="string" [allowFiltering]="false"
                                        [allowSorting]="false"></dxi-column>
                                    <dxi-column dataField="version" dataType="string" [allowFiltering]="false"
                                        [allowSorting]="false"></dxi-column> -->

                                    <dxi-column cellTemplate="actionsTemplate" [allowFiltering]="false"
                                        [allowSorting]="false" [fixed]="true" fixedPosition="right" [width]="70"
                                        [caption]="''" [cssClass]="'actions'"></dxi-column>

                                    <div *dxTemplate="let template of 'actionsTemplate'">
                                        <span class="table-icon dx-icon-edit" [title]="'SHARED.EDIT' | translate"
                                            (click)="openSyncItemModal(template.data)"></span>
                                        <span class="table-icon dx-icon-trash" [title]="'SHARED.DELETE' | translate"
                                            (click)="deleteSyncItemModal(template.data)"></span>
                                    </div>

                                    <div *dxTemplate="let row of 'rowTemplate'">
                                        <text class="text-center" >{{ getRowNumber(row.data, template.data.syncItems) }}</text>
                                    </div>
                                </dx-data-grid>
                            </div>
                        </div>

                    </dx-data-grid>
                </div>
            </div>
        </dx-tab-panel>
    </div>
</div>


<dx-popup width="1020px" maxWidth="80%" height="600px" maxHeight="80%" [(visible)]="isConfigurationItemModalVisible"
    [title]="'DATA_SYNC.CONFIGURATION.EDIT_CONFIGURATION_ITEM' | translate">
    <!-- (onHiding)="closeAddByAttributeModal()" -->
    <dx-scroll-view height="83.5%">

        <div class="container">
            <dx-form #formConfigurationItem class="form-vertical" [formData]="configurationItemModal"
                [showColonAfterLabel]="false" (onFieldDataChanged)="fieldDataChanged($event)">
                <!-- <dxi-item *ngIf="configurationItemModal?.id != null && configurationItemModal?.id != ''" dataField="id"
                    editorType="dxTextBox" [editorOptions]="{ readOnly: true }">
                    <dxo-label location="left" alignment="left" [text]="'SHARED.ID' | translate"></dxo-label>
                </dxi-item> -->

                <dxi-item dataField="type" editorType="dxSelectBox" [editorOptions]="{ dataSource: configTypes, valueExpr: 'value', displayExpr: 'label', searchEnabled: true, readOnly: !((authorities.create && id == null) || (authorities.update && id != null)) }">
                    <dxo-label location="left" alignment="left" [text]="'SHARED.TYPE' | translate"></dxo-label>
                    <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
                </dxi-item>
            </dx-form>
            <div class="mt-3">
                <span class="details-title">{{ 'DATA_SYNC.CONFIGURATION.SYNC_ITEMS' | translate }}</span>
                <dx-data-grid class="smaller-header" [dataSource]="configurationItemModal?.syncItems"
                    [showColumnLines]="false" [showRowLines]="true" [showBorders]="true" [rowAlternationEnabled]="true"
                    (onToolbarPreparing)="onToolbarSyncItemsPreparing($event)">
                    
                    <dxi-column cellTemplate="rowTemplate" dataType="string" [allowFiltering]="false" [allowSorting]="false"
                    [caption]="'SHARED.ROW_NUMBER' | translate"></dxi-column>
                    <dxi-column dataField="clientSpecific" dataType="boolean" [allowFiltering]="false"
                        [allowSorting]="false"></dxi-column>
                    <!-- <dxi-column *ngIf="configurationItemModal?.id != null && configurationItemModal?.id != ''" dataField="id" dataType="string" [allowFiltering]="false" [allowSorting]="false">
                    </dxi-column>
                    <dxi-column *ngIf="configurationItemModal?.id != null && configurationItemModal?.id != ''" dataField="version" dataType="string" [allowFiltering]="false" [allowSorting]="false">
                    </dxi-column> -->
                    <dxi-column cellTemplate="actionsTemplate" [allowFiltering]="false" [allowSorting]="false"
                        [fixed]="true" fixedPosition="right" [width]="70" [caption]="''" [cssClass]="'actions'">
                    </dxi-column>

                    <div *dxTemplate="let template of 'actionsTemplate'">
                        <span class="table-icon dx-icon-edit" [title]="'SHARED.EDIT' | translate"
                            (click)="openSyncItemModal(template.data)"></span>
                        <span class="table-icon dx-icon-trash" [title]="'SHARED.DELETE' | translate"
                            (click)="deleteSyncItemModal(template.data, true)"></span>
                    </div>

                    <div *dxTemplate="let row of 'rowTemplate'">
                        <text class="text-center" >{{ getRowNumber(row.data, configurationItemModal?.syncItems) }}</text>
                    </div>
                </dx-data-grid>
            </div>
        </div>
    </dx-scroll-view>
    <hr>
    <div class="dx-popup-footer">
        <div class="row col-sm-3 pull-right">
            <div class="col-sm">
                <dx-button *ngIf="isConfigurationItemEdit" class="navbar-button btn-block" [height]="32"
                    stylingMode="contained" icon="add"
                    [text]="'DEV-EXTREME.dxDataGrid-editingSaveRowChanges' | translate" type="success"
                    (onClick)="updateConfigurationItem()"></dx-button>
                <dx-button *ngIf="!isConfigurationItemEdit" class="navbar-button btn-block" [height]="32"
                    stylingMode="contained" icon="add" [text]="'DEV-EXTREME.dxDataGrid-editingAddRow' | translate"
                    type="success" (onClick)="saveConfigurationItem()"></dx-button>
            </div>
        </div>
    </div>
</dx-popup>


<dx-popup width="1020px" maxWidth="80%" height="600px" maxHeight="80%" [(visible)]="isSyncItemModalVisible"
    [title]="'DATA_SYNC.CONFIGURATION.EDIT_SYNC_ITEM' | translate">
    <dx-scroll-view height="83.5%">

        <dx-form #formSyncItem class="form-vertical" [formData]="syncItemModel" [showColonAfterLabel]="false"
            (onFieldDataChanged)="fieldDataChanged($event)">
            <!-- <dxi-item *ngIf="syncItemModel.id != null" dataField="id" editorType="dxTextBox"
                [editorOptions]="{ readOnly: true }">
                <dxo-label location="left" alignment="left" [text]="'SHARED.ID' | translate"></dxo-label>
            </dxi-item> -->

            <dxi-item dataField="clientSpecific" editorType="dxCheckBox">
                <dxo-label location="left" alignment="left"></dxo-label>
            </dxi-item>
        </dx-form>
        <div class="container mt-5">
            <span class="details-title">{{ 'DATA_SYNC.CONFIGURATION.FIELD_MAPPINGS' | translate }}</span>
            <dx-data-grid class="smaller-header" [dataSource]="syncItemModel?.fieldMappings" [showColumnLines]="false"
                [showRowLines]="true" [showBorders]="true" [rowAlternationEnabled]="true">
                <dxo-editing mode="row" [allowUpdating]="true" [allowDeleting]="true" [allowAdding]="true">
                </dxo-editing>
                <dxi-column dataField="serverFieldName" dataType="string" [allowFiltering]="false"
                    [allowSorting]="false"></dxi-column>
                <dxi-column dataField="clientFieldName" dataType="string" [allowFiltering]="false"
                    [allowSorting]="false"></dxi-column>
                <dxi-column dataField="ignore" dataType="string" [allowFiltering]="false" [allowSorting]="false">                    
                    <dxo-lookup [dataSource]="fieldMappingsIgnore" valueExpr="value" displayExpr="label"></dxo-lookup>
                </dxi-column>
                <dxi-column dataField="key" dataType="boolean" [allowFiltering]="false" [allowSorting]="false">
                </dxi-column>
            </dx-data-grid>
        </div>

        <div class="container mt-5">
            <span class="details-title">{{ 'DATA_SYNC.CONFIGURATION.OBJECTS' | translate }}</span>
            <dx-data-grid class="smaller-header" [dataSource]="syncItemModel?.objects" [showColumnLines]="false"
                [showRowLines]="true" [showBorders]="true" [rowAlternationEnabled]="true"
                (onToolbarPreparing)="onToolbarObjectsPreparing($event)">
                <!-- <dxo-editing mode="row" [allowUpdating]="false" [allowDeleting]="false" [allowAdding]="false"></dxo-editing> -->
                <dxi-column cellTemplate="rowTemplate" dataType="string" [allowFiltering]="false" [allowSorting]="false"
                [caption]="'SHARED.ROW_NUMBER' | translate"></dxi-column>

                <dxi-column dataField="type" dataType="string" [allowFiltering]="false" [allowSorting]="false">
                </dxi-column>
                <dxi-column dataField="name" dataType="string" [allowFiltering]="false" [allowSorting]="false">
                </dxi-column>
                <!-- <dxi-column *ngIf="syncItemModel.id != null" dataField="id" dataType="string" [allowFiltering]="false" [allowSorting]="false">
                </dxi-column>
                <dxi-column *ngIf="syncItemModel.id != null" dataField="version" dataType="string" [allowFiltering]="false" [allowSorting]="false">
                </dxi-column> -->

                <dxi-column cellTemplate="actionsTemplate" [allowFiltering]="false" [allowSorting]="false"
                    [fixed]="true" fixedPosition="right" [width]="70" [caption]="''" [cssClass]="'actions'">
                </dxi-column>

                <div *dxTemplate="let row of 'rowTemplate'">
                    <text class="text-center" >{{ getRowNumber(row.data, syncItemModel?.objects) }}</text>
                </div>

                <div *dxTemplate="let template of 'actionsTemplate'">
                    <span class="table-icon dx-icon-edit" [title]="'SHARED.EDIT' | translate"
                        (click)="openObjectItemModal(template.data)"></span>
                    <span class="table-icon dx-icon-trash" [title]="'SHARED.DELETE' | translate"
                        (click)="deleteObjectItemModal(template.data)"></span>
                </div>
            </dx-data-grid>
        </div>

        <div class="container mt-5">
            <span class="details-title">{{ 'DATA_SYNC.CONFIGURATION.ASSOCIATED_ITEMS' | translate }}</span>
                <dx-data-grid class="smaller-header" [dataSource]="syncItemModel?.associatedItems"
                    [showColumnLines]="false" [showRowLines]="true" [showBorders]="true" [rowAlternationEnabled]="true"
                    (onToolbarPreparing)="onToolbarAssociatedItemsPreparing($event)">
                    <dxi-column cellTemplate="rowTemplate" dataType="string" [allowFiltering]="false" [allowSorting]="false"
                    [caption]="'SHARED.ROW_NUMBER' | translate"></dxi-column>    

                    <dxi-column dataField="clientSpecific" dataType="boolean" [allowFiltering]="false"
                        [allowSorting]="false"></dxi-column>
                    <!-- <dxi-column *ngIf="syncItemModel?.id != null && syncItemModel?.id != ''" dataField="id" dataType="string" [allowFiltering]="false" [allowSorting]="false">
                    </dxi-column>
                    <dxi-column *ngIf="syncItemModel?.id != null && syncItemModel?.id != ''" dataField="version" dataType="string" [allowFiltering]="false" [allowSorting]="false">
                    </dxi-column> -->
                    <dxi-column cellTemplate="actionsTemplate" [allowFiltering]="false" [allowSorting]="false"
                        [fixed]="true" fixedPosition="right" [width]="70" [caption]="''" [cssClass]="'actions'">
                    </dxi-column>

                    <div *dxTemplate="let template of 'actionsTemplate'">
                        <span class="table-icon dx-icon-edit" [title]="'SHARED.EDIT' | translate"
                            (click)="openAssociatedItemModal(template.data)"></span>
                        <span class="table-icon dx-icon-trash" [title]="'SHARED.DELETE' | translate"
                            (click)="deleteAssociatedItemModal(template.data)"></span>
                    </div>

                    <div *dxTemplate="let row of 'rowTemplate'">
                        <text class="text-center" >{{ getRowNumber(row.data, syncItemModel?.associatedItems) }}</text>
                    </div>
                </dx-data-grid>
        </div>
    </dx-scroll-view>
    <hr>
    <div class="dx-popup-footer">
        <div class="row col-sm-3 pull-right">
            <div class="col-sm">
                <dx-button *ngIf="isSyncItemModalEdit" class="navbar-button btn-block" [height]="32"
                stylingMode="contained" icon="add"
                [text]="'DEV-EXTREME.dxDataGrid-editingSaveRowChanges' | translate" type="success"
                (onClick)="updateSyncItem()"
                [disabled]="disabledSyncItemModal()">
                </dx-button>
                <dx-button *ngIf="!isSyncItemModalEdit" class="navbar-button btn-block" [height]="32"
                    stylingMode="contained" icon="add" [text]="'DEV-EXTREME.dxDataGrid-editingAddRow' | translate"
                    type="success" (onClick)="saveSyncItem()" [disabled]="disabledSyncItemModal()"></dx-button>
            </div>
        </div>
    </div>
</dx-popup>


<dx-popup width="1020px" maxWidth="80%" height="600px" maxHeight="80%" [(visible)]="isObjectItemModalVisible"
    [title]="'DATA_SYNC.CONFIGURATION.EDIT_OBJECT' | translate">
    <dx-scroll-view height="83.5%">
        <dx-form #formObjectItem class="form-vertical" [formData]="objectItemModel" [showColonAfterLabel]="false"
            (onFieldDataChanged)="fieldDataChanged($event)">
            <!-- <dxi-item *ngIf="objectItemModel.id != null" dataField="id" editorType="dxTextBox"
                [editorOptions]="{ readOnly: true }">
                <dxo-label location="left" alignment="left" [text]="'SHARED.ID' | translate"></dxo-label>
            </dxi-item> -->

            <dxi-item dataField="type" editorType="dxSelectBox" [editorOptions]="{ dataSource: objectTypes, valueExpr: 'value', displayExpr: 'label', searchEnabled: true, readOnly: !((authorities.create && id == null) || (authorities.update && id != null)) }">
                <dxo-label location="left" alignment="left" [text]="'SHARED.TYPE' | translate"></dxo-label>
                <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
            </dxi-item>

            <dxi-item dataField="name" editorType="dxTextBox">
                <dxo-label location="left" alignment="left"></dxo-label>
                <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
            </dxi-item>
        </dx-form>

        <div class="container mt-3">
            <span class="details-title">{{ 'DATA_SYNC.CONFIGURATION.SELECTED_CONDITIONS' | translate }}</span>
            <dx-data-grid class="smaller-header" [dataSource]="objectItemModel?.selectConditions"
                [showColumnLines]="false" [showRowLines]="true" [showBorders]="true" [rowAlternationEnabled]="true">
                <dxo-editing mode="row" [allowUpdating]="true" [allowDeleting]="true" [allowAdding]="true">
                </dxo-editing>
                
                <dxi-column cellTemplate="rowTemplate" dataType="string" [allowFiltering]="false" [allowSorting]="false"
                [caption]="'SHARED.ROW_NUMBER' | translate"></dxi-column>
                <dxi-column dataField="condition" dataType="string" [allowFiltering]="false" [allowSorting]="false">
                    <dxo-lookup [dataSource]="selectionConditions" valueExpr="value" displayExpr="label"></dxo-lookup>
                </dxi-column>
                <dxi-column  dataField="value" dataType="string" [allowFiltering]="false" [allowSorting]="false">
                </dxi-column>
                <!-- <dxi-column *ngIf="objectItemModel.id != null" dataField="id" dataType="string" [allowFiltering]="false" [allowSorting]="false">
                </dxi-column>
                <dxi-column *ngIf="objectItemModel.id != null" dataField="version" dataType="string" [allowFiltering]="false" [allowSorting]="false">
                </dxi-column> -->
                <div *dxTemplate="let row of 'rowTemplate'">
                    <text class="text-center" >{{ getRowNumber(row.data,objectItemModel?.selectConditions) }}</text>
                </div>

            </dx-data-grid>
        </div>

        <div class="container mt-3">
            <span class="details-title">{{ 'DATA_SYNC.CONFIGURATION.ASSOCIATIONS_FIELD' | translate }}</span>
            <dx-data-grid class="smaller-header" [dataSource]="objectItemModel?.associationFields"
                [showColumnLines]="false" [showRowLines]="true" [showBorders]="true" [rowAlternationEnabled]="true">
                <dxo-editing mode="row" [allowUpdating]="true" [allowDeleting]="true" [allowAdding]="true">
                </dxo-editing>
                <dxi-column dataField="masterField" dataType="string" [allowFiltering]="false" [allowSorting]="false">
                </dxi-column>
                <dxi-column dataField="detailField" dataType="string" [allowFiltering]="false" [allowSorting]="false">
                </dxi-column>
            </dx-data-grid>
        </div>
    </dx-scroll-view>

    <hr>
    <div class="dx-popup-footer">
        <div class="row col-sm-3 pull-right">
            <div class="col-sm">
                <dx-button *ngIf="isObjectItemModalEdit" class="navbar-button btn-block" [height]="32"
                    stylingMode="contained" icon="add"
                    [text]="'DEV-EXTREME.dxDataGrid-editingSaveRowChanges' | translate" type="success"
                    (onClick)="updateObjectItem()"></dx-button>
                <dx-button *ngIf="!isObjectItemModalEdit" class="navbar-button btn-block" [height]="32"
                    stylingMode="contained" icon="add" [text]="'DEV-EXTREME.dxDataGrid-editingAddRow' | translate"
                    type="success" (onClick)="saveObjectItem()"></dx-button>
            </div>
        </div>
    </div>
</dx-popup>


<dx-popup width="1020px" maxWidth="80%" height="600px" maxHeight="80%" [(visible)]="isAssociatedItemModalVisible"
    [title]="'DATA_SYNC.CONFIGURATION.EDIT_ASSOCIATED_ITEM' | translate">
    <dx-scroll-view height="83.5%">
        <dx-form #formAssociatedItem class="form-vertical" [formData]="associatedItemModel" [showColonAfterLabel]="false"
        (onFieldDataChanged)="fieldDataChanged($event)">
        <!-- <dxi-item *ngIf="associatedItemModel.id != null" dataField="id" editorType="dxTextBox"
            [editorOptions]="{ readOnly: true }">
            <dxo-label location="left" alignment="left" [text]="'SHARED.ID' | translate"></dxo-label>
        </dxi-item> -->

        <dxi-item dataField="clientSpecific" editorType="dxCheckBox">
            <dxo-label location="left" alignment="left"></dxo-label>
        </dxi-item>
    </dx-form>
    <div class="container mt-5">
        <span class="details-title">{{ 'DATA_SYNC.CONFIGURATION.FIELD_MAPPINGS' | translate }}</span>
        <dx-data-grid class="smaller-header" [dataSource]="associatedItemModel?.fieldMappings" [showColumnLines]="false"
            [showRowLines]="true" [showBorders]="true" [rowAlternationEnabled]="true">
            <dxo-editing mode="row" [allowUpdating]="true" [allowDeleting]="true" [allowAdding]="true">
            </dxo-editing>
            <dxi-column dataField="serverFieldName" dataType="string" [allowFiltering]="false"
                [allowSorting]="false"></dxi-column>
            <dxi-column dataField="clientFieldName" dataType="string" [allowFiltering]="false"
                [allowSorting]="false"></dxi-column>
            <dxi-column dataField="ignore" dataType="string" [allowFiltering]="false" [allowSorting]="false">                    
                <dxo-lookup [dataSource]="fieldMappingsIgnore" valueExpr="value" displayExpr="label"></dxo-lookup>
            </dxi-column>
            <dxi-column dataField="key" dataType="boolean" [allowFiltering]="false" [allowSorting]="false">
            </dxi-column>
        </dx-data-grid>
    </div>

    <div class="container mt-5">
        <span class="details-title">{{ 'DATA_SYNC.CONFIGURATION.OBJECTS' | translate }}</span>
        <dx-data-grid class="smaller-header" [dataSource]="associatedItemModel?.objects" [showColumnLines]="false"
            [showRowLines]="true" [showBorders]="true" [rowAlternationEnabled]="true"
            (onToolbarPreparing)="onToolbarAssociatedObjectsPreparing($event)">
            <!-- <dxo-editing mode="row" [allowUpdating]="false" [allowDeleting]="false" [allowAdding]="false"></dxo-editing> -->
            
            <dxi-column cellTemplate="rowTemplate" dataType="string" [allowFiltering]="false" [allowSorting]="false"
            [caption]="'SHARED.ROW_NUMBER' | translate"></dxi-column>
            <dxi-column dataField="type" dataType="string" [allowFiltering]="false" [allowSorting]="false">
            </dxi-column>
            <dxi-column dataField="name" dataType="string" [allowFiltering]="false" [allowSorting]="false">
            </dxi-column>
            <!-- <dxi-column *ngIf="associatedItemModel.id != null" dataField="id" dataType="string" [allowFiltering]="false" [allowSorting]="false">
            </dxi-column>
            <dxi-column *ngIf="associatedItemModel.id != null" dataField="version" dataType="string" [allowFiltering]="false" [allowSorting]="false">
            </dxi-column> -->

            <dxi-column cellTemplate="actionsTemplate" [allowFiltering]="false" [allowSorting]="false"
                [fixed]="true" fixedPosition="right" [width]="70" [caption]="''" [cssClass]="'actions'">
            </dxi-column>

            <div *dxTemplate="let row of 'rowTemplate'">
                <text class="text-center" >{{ getRowNumber(row.data, associatedItemModel?.objects) }}</text>
            </div>

            <div *dxTemplate="let template of 'actionsTemplate'">
                <span class="table-icon dx-icon-edit" [title]="'SHARED.EDIT' | translate"
                    (click)="openObjectItemModal(template.data, true)"></span>
                <span class="table-icon dx-icon-trash" [title]="'SHARED.DELETE' | translate"
                    (click)="deleteObjectItemModal(template.data, true)"></span>
            </div>
        </dx-data-grid>
    </div>
    </dx-scroll-view>
    <hr>
    <div class="dx-popup-footer">
        <div class="row col-sm-3 pull-right">
            <div class="col-sm">
                <dx-button *ngIf="isAssociatedItemEdit" class="navbar-button btn-block" [height]="32"
                    stylingMode="contained" icon="add"
                    [text]="'DEV-EXTREME.dxDataGrid-editingSaveRowChanges' | translate" type="success"
                    (onClick)="updateAssociatedItem()"
                    [disabled]="disabledAssociatedItemModal()"></dx-button>
                <dx-button *ngIf="!isAssociatedItemEdit" class="navbar-button btn-block" [height]="32"
                    stylingMode="contained" icon="add" [text]="'DEV-EXTREME.dxDataGrid-editingAddRow' | translate"
                    type="success" (onClick)="saveAssociatedItem()"
                    [disabled]="disabledAssociatedItemModal()"></dx-button>
            </div>
        </div>
    </div>
</dx-popup>

